import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import Icon from 'react-fa';

const EditDetailHeader = ({ onEditCancel }) => (
  <div className='saved-job-detail-header'>
    <h5>Job Details</h5>

    <span className='saved-job-edit-button-container'>
      <Button
        className='saved-job-edit-button btn-new'
        bsStyle='warning'
        onClick={onEditCancel}
      >
        <Icon name='times' />
      </Button>
    </span>
  </div>
);

export default EditDetailHeader;

EditDetailHeader.propTypes = {
  onEditCancel: PropTypes.func,
};
